
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `הקישו על "פתיחה בדפדפן…"`,
's182ab2d6c997515f': `הוסיפו למסך הבית לחוויה מקיפה וגישה קלה.`,
's224cbcec014ef6b5': `לחצו על שיתוף בסרגל הניווט`,
's233af3b7eb5e0364': `הוספה לדף הבית`,
's37a9e8aec5713460': `עוד`,
's4c3161035f3a1413': `לחצו על התפריט`,
's4e1e10a6ca408245': `הקישו על "הוספה למסך הבית"`,
's6196153c4b0c1ea0': `התקנה`,
's633502f7cff4f847': `פתחו את תפריט הדפדפן`,
's681e399d63311fba': `הצג גלריה`,
's6d14a4f70ba4e3cf': `לחצו על התפריט אם אין סמל שיתוף`,
's922329d6f6213590': `הוסיפו ל-Dock`,
's9c63a79ffcc2a3a3': `לחצו על "הוספה למסך הבית"`,
'sa2d71bfd9525168d': `לחצו על "הוספה ל-Dock"`,
'sa5ef80b4bb9b39f8': `הסתרת גלריה`,
'sb527eca1c1d7e7be': `פתחו את תפריט הדפדפן המובנה`,
'sba52286c21552a4e': `התקינו במכשירכם לחוויה מקיפה וגישה קלה.`,
'sc16e00a7a8b2fde2': `חזרה`,
'scdaf4bbff76674c8': `הוספה למסך הבית`,
'sd18a5b85f599ff3c': `פתחו את הקישור שהועתק ב-Safari`,
'se72fc3a84f9b51c3': `הקישו להעתקת הקישור`,
'se740f75b95a51807': `הוסיפו ל-Dock לחוויה מקיפה וגישה קלה.`,
'sfa6c42cdf48d93d2': `אבל הדפדפן הזה לא תומך בתכונה הזו. פתחו את הקישור בדפדפן חיצוני כדי להמשיך.`,
'sfb78526365796a41': `לחצו על "הצג עוד" בתפריט השיתוף`,
'sfea652f6580ff086': `לאתר זה יש פונקציונליות של אפליקציה.`,
    };
  